module.exports = __webpack_public_path__ + "logo.a4adb91c754f13d2893d.png";


//////////////////
// WEBPACK FOOTER
// /var/www/portaldev/bullseye/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = styles